import React from "react";

export const CasesHigh = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7" fill="#FF7800" />
      <path
        d="M8.7 5L9.9595 6.2595L7.2755 8.9435L5.0755 6.7435L1 10.8245L1.7755 11.6L5.0755 8.3L7.2755 10.5L10.7405 7.0405L12 8.3V5H8.7Z"
        fill="black"
      />
    </svg>
  );
};

export default CasesHigh;
